import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

import { useDrawerContext } from 'app/shared/contexts/drawer';
import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const REQUEST_OMITTED_TOOLTIP = 'Available when requesting 30 events or fewer';

export default function EventButton({ title, Icon, dataTestId, disabledKey, eventTab, eventData }) {
  const { launchDrawer } = useDrawerContext();
  const { requestOmitted } = useEventDebuggerTableContext();

  const disabled = !eventData[disabledKey];
  const tooltipTitle =
    disabled && disabledKey === 'requestHeaders' && requestOmitted ? `${title} - ${REQUEST_OMITTED_TOOLTIP}` : title;

  const onClick = () => {
    launchDrawer({
      initialTab: eventTab,
      eventData,
    });
  };

  return (
    <WithTooltip show title={tooltipTitle}>
      <IconButton data-test-id={dataTestId} disabled={disabled} onClick={onClick}>
        <Icon />
      </IconButton>
    </WithTooltip>
  );
}

EventButton.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  dataTestId: PropTypes.string,
  disabledKey: PropTypes.string,
  eventTab: PropTypes.string,
  eventData: PropTypes.shape({
    inputEvent: PropTypes.string,
    outputEvent: PropTypes.string,
    requestHeaders: PropTypes.string,
    requestBody: PropTypes.string,
    response: PropTypes.string,
  }),
};
